/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {initiateInstrumentSelection} from '../api'

export const useMutationInitiateInstrumentSelection = createReactQueryMutationHook('initiateInstrumentSelection', initiateInstrumentSelection)
